import React from 'react'

const OpenEye = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
    return (
        <svg
            width="15"
            height="12"
            viewBox="0 0 15 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M14.9211 3.95559L14.7458 3.74124C14.7068 3.70227 13.9858 2.78645 12.7387 1.87062C11.063 0.643027 9.25081 0 7.47762 0C5.70442 0 3.89226 0.643027 2.21649 1.87062C1.00838 2.78645 0.267928 3.70227 0.248442 3.74124L0.0730712 3.95559C-0.0243571 4.0725 -0.0243571 4.24787 0.0730712 4.36479L0.248442 4.57913C0.287413 4.6181 1.00838 5.53392 2.25546 6.44975C3.93123 7.67735 5.74339 8.32037 7.51659 8.32037C9.28978 8.32037 11.1019 7.67735 12.7777 6.44975C14.0248 5.53392 14.7458 4.6181 14.7847 4.57913L14.9601 4.36479C15.0186 4.24787 15.0186 4.0725 14.9211 3.95559ZM7.4971 7.34609C5.72391 7.34609 4.30146 5.92364 4.30146 4.15044C4.30146 2.37725 5.72391 0.954797 7.4971 0.954797C9.2703 0.954797 10.6927 2.37725 10.6927 4.15044C10.6927 5.92364 9.2703 7.34609 7.4971 7.34609Z"
                fill="#696158"
            />
            <path
                d="M7.49733 1.96802C6.28922 1.96802 5.31494 2.9423 5.31494 4.15041C5.31494 5.35852 6.28922 6.3328 7.49733 6.3328C8.70544 6.3328 9.67973 5.35852 9.67973 4.15041C9.67973 2.9423 8.70544 1.96802 7.49733 1.96802ZM9.1731 4.15041C9.1731 5.06624 8.43265 5.82618 7.49733 5.82618C7.30248 5.82618 7.16608 5.67029 7.16608 5.49492C7.16608 5.39749 7.20505 5.31955 7.26351 5.26109C7.32196 5.20263 7.39991 5.16366 7.49733 5.16366C8.04293 5.16366 8.4911 4.71549 8.4911 4.1699C8.4911 3.97504 8.64699 3.83864 8.82236 3.83864C9.01721 3.81915 9.1731 3.97504 9.1731 4.15041Z"
                fill="#696158"
            />
        </svg>
    )
}

export default OpenEye
